import { BOARD, BOT_LEVEL_NAMES, CURRENCY, PLAYER_COLORS } from "@grundbesitz/shared";
import type { BotLevel, PlayerColorId, PublicGameState, RoomMember } from "@grundbesitz/shared";

/** "M 240", with a no-break space and German thousands separators ("M 1.500"). */
export function formatMoney(amount: number): string {
  return `${CURRENCY} ${amount.toLocaleString("de-DE")}`;
}

export function fieldName(index: number): string {
  return BOARD[index]?.name ?? `Feld ${index}`;
}

export function colorHex(color: PlayerColorId | null | undefined): string {
  return PLAYER_COLORS.find((c) => c.id === color)?.hex ?? "#888888";
}

/** "Bot · Schwer", or just "Bot" without a level. */
export function botLabel(level: BotLevel | null | undefined): string {
  return level ? `Bot · ${BOT_LEVEL_NAMES[level]}` : "Bot";
}

/** Name of a player by id (game players are named in the game state, members in the room). */
export function playerName(game: PublicGameState | null, members: RoomMember[], id: string): string {
  return game?.players.find((p) => p.id === id)?.name ?? members.find((m) => m.id === id)?.name ?? "Unbekannt";
}
